import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-add-transaction-action-sheet',
  templateUrl: './add-transaction-action-sheet.component.html',
  styleUrls: ['./add-transaction-action-sheet.component.scss']
})
export class AddTransactionActionSheetComponent {
  
  @Output() submitted = new EventEmitter<boolean>();
  @Input() Mode : string; 
  isOpen : boolean = true;
  Amount : number;
  Narration : string;
  isLoading: boolean = false;

  constructor(private apiService: ApiService,private router:Router ) { }

  submitTran() {
    this.isLoading = true;
    this.apiService.submitTransaction(this.Amount).subscribe((res:any)=>{
      this.isLoading = false;
      if(res.Result === 'Success') {
        // console.log('Transaction added')
        this.submitted.emit(true);
        // this.isShowAdd = false;
        // this.getTransactions();
        // this.getBalance();
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
      console.log('------------------------')
      console.log(error)
      console.log('------------------------')
    });
    

  }
}
